import {isNil} from "lodash";

export default {
    isUserLoggedIn: state => !isNil(state.user),
    isUserAdmin   : state => !isNil(state.user) && state.user.role === "administrator",
    getUserID     : state => state.user.id,
    getUser       : state => state.user,
    getUsers      : state => state.users
};
